// Rangées « Le blog » et « L'aventure » (refonte 2026), porté de src/sections/blog.js du prototype :
// défilement natif (trackpad, swipe) + curseur Arrow sur la carte coupée par le bord droit.
import { arrowCursor } from '@oqp/arrow-cursor';

function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const track = root.querySelector('.posts__track');
  if (!track) return;
  const cut = e => {
    const li = e.target.closest('.post');
    return !!li && li.getBoundingClientRect().right > root.getBoundingClientRect().right + 1;
  };
  const stepBy = () => track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
  root.addEventListener('click', e => {
    if (!matchMedia('(hover: hover)').matches || !cut(e)) return;
    e.preventDefault();
    const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    track.scrollBy({ left: end ? -track.scrollWidth : stepBy() });   // au bout : retour au début
  }, true);
  arrowCursor(root, cut);
}

document.querySelectorAll('[data-posts]').forEach(init);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-posts]').forEach(init));
